import { render } from "./RoleEdit.html?vue&type=template&id=7ff66894&scoped=true&ts=true"
import script from "./RoleEdit.ts?vue&type=script&lang=ts"
export * from "./RoleEdit.ts?vue&type=script&lang=ts"

import "./RoleEdit.css?vue&type=style&index=0&id=7ff66894&scoped=true&lang=css"

import exportComponent from "/home/dev/deployment/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ff66894"]])

export default __exports__